(() => {
  const main = document.querySelector('main[data-template^="product"]');

  if (!main) return;

  const purchaseAreaSelector = '[data-testid="product-information"], .product-information';
  const nativeControlSelector =
    'form, product-form-component, shopify-accelerated-checkout, quantity-selector, dialog, summary';
  const callToActionPattern = /\b(get|shop|order|choose|claim|select|buy)\b.*\b(now|today|yours|mine)\b/i;
  const callToActionClassPattern = /(^|[-_])(button|btn|cta|shop|buy|order|claim)([-_]|$)/i;

  function getHeaderOffset() {
    const header = document.querySelector('header-component, .header-section, header');
    return header ? header.getBoundingClientRect().height + 12 : 12;
  }

  function scrollToPurchaseArea() {
    const purchaseArea = document.querySelector(purchaseAreaSelector);

    if (!purchaseArea) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    const top = purchaseArea.getBoundingClientRect().top + window.scrollY - getHeaderOffset();
    window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });
  }

  function isScrollLink(control) {
    if (!(control instanceof HTMLAnchorElement)) return false;

    const rawHref = control.getAttribute('href');

    if (!rawHref || rawHref === '#') return true;
    if (!rawHref.startsWith('#')) return false;

    const hash = rawHref.toLowerCase();
    const knownTargets = ['#top', '#product', '#product-top', '#buy', '#buy-now', '#product-form'];

    if (knownTargets.includes(hash)) return true;

    try {
      return document.querySelector(rawHref) === null;
    } catch {
      return true;
    }
  }

  function isNativePurchaseControl(control) {
    if (!control.closest(nativeControlSelector)) return false;

    return control.matches('button, input, a, [role="button"]') || Boolean(control.closest('button, input, a, [role="button"]'));
  }

  function hasCallToActionText(element) {
    const text = element.textContent.replace(/\s+/g, ' ').trim();

    return text.length > 0 && text.length <= 100 && callToActionPattern.test(text);
  }

  function findControl(event) {
    const path = event.composedPath().filter((node) => node instanceof HTMLElement && main.contains(node));
    const explicitControl = path.find((node) =>
      node.matches('[data-scroll-to-product], .product-scroll-to-top, .product-cta-button')
    );

    if (explicitControl) return explicitControl;

    const standardControl = path.find((node) => node.matches('a, button, [role="button"], input[type="button"]'));

    if (standardControl) return standardControl;

    const styledControl = path.find((node) => {
      const className = typeof node.className === 'string' ? node.className : '';
      return callToActionClassPattern.test(className) && hasCallToActionText(node);
    });

    if (styledControl) return styledControl;

    return path.find((node) => hasCallToActionText(node));
  }

  function isScrollButton(control) {
    if (control instanceof HTMLButtonElement && (control.type === 'submit' || control.disabled)) return false;
    if (control instanceof HTMLInputElement && (control.type === 'submit' || control.disabled)) return false;

    return hasCallToActionText(control);
  }

  document.addEventListener('click', (event) => {
    const control = findControl(event);

    if (!control || control.hasAttribute('data-no-scroll-to-product')) return;

    const explicitlyEnabled = control.matches('[data-scroll-to-product], .product-scroll-to-top, .product-cta-button');

    if (!explicitlyEnabled && isNativePurchaseControl(control)) return;
    if (!explicitlyEnabled && !isScrollLink(control) && !isScrollButton(control)) return;

    event.preventDefault();
    event.stopPropagation();
    scrollToPurchaseArea();
  }, true);
})();
